import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

const ARROW_SIZE = "16px";

export const CalloutOuter = styled.div(({ theme }) => ({
    width: "100%",
    marginTop: theme.spacing.x7,
    marginLeft: `calc(${theme.spacing.xSmall} * -1)`,
}));

export const CalloutBubble = styled.div<{
    bgColor?: string;
}>(({ theme, bgColor }) => ({
    position: "relative",
    background: bgColor,
    borderRadius: theme.cornerRadius.xSmall,
    padding: `${theme.spacing.xSmall} 0 ${theme.spacing.x5} ${theme.spacing.x6}`,
    display: "flex",
    alignItems: "center",

    "&::before": {
        content: '""',
        position: "absolute",
        top: "-6px",
        left: theme.spacing.x20,
        width: ARROW_SIZE,
        height: ARROW_SIZE,
        background: bgColor,
        transform: "rotate(45deg)",
        borderTopLeftRadius: theme.cornerRadius.xxSmall,
    },
}));

export const CalloutMessage = styled(Text)(() => ({
    flex: 1,
    minWidth: 0,
}));
